import lodash from "lodash";
import { BrandModel } from "models";
import { fetcher } from "utils/net";

import useSWR from "swr";
import { useAuth } from "providers/auth";
import { useEffect, useState } from "react";
import { UseBrandsProps } from "./types";

export function useBrands(props?: UseBrandsProps) {
  const limit = lodash(props).get("limit", 5);
  const offset = lodash(props).get("offset", 0);

  const [brands, setBrands] = useState<BrandModel[]>([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [itemPerPage, setItemPerPage] = useState<number>(0);

  const { accessToken } = useAuth();
  const { data, error, isLoading, mutate } = useSWR(() => {
    if (!accessToken) return undefined;

    return [`/brands?limit=${limit}&offset=${offset}`, accessToken];
  }, fetcher);

  useEffect(() => {
    if (!data) return;

    const bs = data.data.map((d: any) => BrandModel.fromResponse(d));
    setBrands(bs);

    // We need to set the totalCount
    // And itemPerPage based on the data.pagination.totalCount and data.pagination.limit
    if (!data.pagination) return;
    setTotalCount(data.pagination.total_count);
    setItemPerPage(data.pagination.limit);
  }, [data]);

  return {
    brands: brands,
    isLoading: isLoading,
    error: error,
    totalCount: totalCount,
    itemPerPage: itemPerPage,
    mutate: mutate,
  };
}
